
import { onMounted } from '@vue/runtime-core'
import { useStore } from 'vuex'
export default {
  name: 'ModalBase',
  setup() {
    const { commit } = useStore()
    onMounted(() => commit('fixBody'))
    return {
      commit
    }
  }
}
